import { ObjetKForm, requiredRule, combineRules } from '@siclop/kstone-vue'

export class ProjectTypeForm extends ObjetKForm {
  code: string = ''
  label: string = ''
  description?: string
  icon?: string
  order: number = 0
  isActive: boolean = true
  estimationScaleIds: number[] = []

  static validationRules = {
    code: combineRules(requiredRule('Le code est obligatoire')),
    label: combineRules(requiredRule('Le libellé est obligatoire'))
  }

  constructor(data?: Partial<ProjectTypeForm>) {
    super(data)
    if (data) {
      this.code = data.code ?? ''
      this.label = data.label ?? ''
      this.description = data.description
      this.icon = data.icon
      this.order = data.order ?? 0
      this.isActive = data.isActive ?? true
      this.estimationScaleIds = data.estimationScaleIds ?? []
    }
  }
}
